module.exports = __webpack_public_path__ + "media/images/pc/top/area_brand_tvb-e87c15b890d3ba9d75312951bcc9ef8d.webp";